import React from 'react';
import styles from "../../styles.module.scss"

export const DataRow = ({ label, value }) => {
    return (
        <div className='d-flex justify-content-between'>
            <span className={styles['review-details-row-label']}>{label}</span>
            <span className={styles['review-details-row-value']}>{value || "-"}</span>
        </div>
    )
}

const labelFieldMapping = [
    { label: "Student Name", field: "studentName" },
    { label: "PSID", field: "psid" },
    { label: "Father's Name", field: "studentFatherName" },
    { label: "Mobile number", field: "studentMobileNumber" },
    { label: "Email ID", field: "studentEmailId" },
    { label: "Address", field: "address" },
    { label: "City", field: "city" },
    { label: "State", field: "state" },
]

const StudentDetails = ({ studentDetails }) => {
    return (
        <>
            <div className={`mb-2 ${styles['review-details-row-value']}`}>Student Details</div>

            {labelFieldMapping?.map(el =>
                <DataRow key={el?.label} label={el?.label} value={studentDetails?.[el?.field]} />
            )}

            <hr className='my-3' />
        </>
    );
}

export default StudentDetails;